/* heon-plp.js: owned by the plp team (2026-09-26). Loaded by snippets/heon-head.liquid on collection, search and
   list-collections pages. Price and sort menus (<details data-hh-dd>) and "Show more" (a link to the next page,
   [data-hh-more-btn]) in sections/main-collection-heon.liquid and main-search-heon.liquid.
   Round 2: "Show more" writes ?page=N into the address (history.replaceState), and the page remembers how far down it
   was. Coming back to ?page=N (Back from a piece, or a shared link), the earlier pages are fetched and put back above,
   and the scroll position returns. */
(() => {
  const T = (k, d) => { const s = window.HeonI18n && window.HeonI18n[k]; return typeof s === 'string' && s ? s : d; };   // the page's language (snippets/heon-i18n-js), else the English default
  const phone = matchMedia('(max-width: 760px)');
  const root = document.documentElement;

  // ---- menus: one open at a time; Esc, the close button or a click outside closes; on phones they are sheets ----
  const menus = () => [...document.querySelectorAll('details[data-hh-dd]')];
  const lock = () => root.classList.toggle('hh-pl-locked', phone.matches && menus().some(d => d.open));
  document.addEventListener('toggle', e => {
    const d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.matches('[data-hh-dd]')) return;
    if (d.open) menus().forEach(o => { if (o !== d) o.open = false; });
    const btn = d.querySelector('summary');
    if (btn) btn.setAttribute('aria-expanded', d.open);
    if (d.open && phone.matches) {
      const cur = d.querySelector('[aria-current]') || d.querySelector('.hh-pl-dd__panel a');
      if (cur) cur.focus({ preventScroll: true });
    }
    lock();
  }, true);
  const close = (d, focus) => { d.open = false; if (focus) d.querySelector('summary').focus(); };
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const d = menus().find(o => o.open);
    if (d) { e.preventDefault(); close(d, true); }
  });
  document.addEventListener('click', e => {
    const x = e.target.closest('[data-hh-dd-close]');
    if (x) { close(x.closest('details'), true); return; }
    // the invisible layer is part of the summary: a click on it lands on the summary and toggles the menu shut
  });
  // keyboard users leaving the menu with Tab close it
  document.addEventListener('focusin', e => {
    menus().forEach(d => { if (d.open && !d.contains(e.target)) d.open = false; });
  });
  menus().forEach(d => { const s = d.querySelector('summary'); if (s) s.setAttribute('aria-expanded', d.open); });
  phone.addEventListener && phone.addEventListener('change', lock);

  // ---- Show more ----
  const itemsOf = doc => [...doc.querySelectorAll('.hh-pl-grid > li')];
  const getPage = async url => {
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(res.status);
    return new DOMParser().parseFromString(await res.text(), 'text/html');
  };
  // one "More pieces you may like" line per grid (search)
  const keepItem = (grid, li) => !(li.matches('[data-hh-break]') && grid.querySelector('[data-hh-break]'));
  const remember = extra => { try { history.replaceState(Object.assign({}, history.state, extra), ''); } catch (e) {} };
  const setCount = (nav, grid) => {
    const count = nav && nav.querySelector('.hh-pl-more__count'), bar = nav && nav.querySelector('.hh-pl-more__bar i');
    if (!count) return;
    // the total: "of 120" in English; another language words the line its own way (heon.common.showing_of), so there it is the largest number
    let m = count.textContent.match(/of\s+([\d,]+)/);
    if (!m && window.HeonI18n) { const ns = (count.textContent.match(/\d[\d.,\u00a0\u202f]*/g) || []).map(x => x.replace(/\D/g, '')); if (ns.length) m = [0, String(Math.max(...ns))]; }
    if (!m) return;
    const total = parseInt(m[1].replace(/,/g, ''), 10), n = grid.querySelectorAll('.hh-pl-grid__item').length;
    count.textContent = T('showing_of', 'Showing [s] of [t]').replace('[s]', n).replace('[t]', total);
    if (bar && total) bar.style.width = Math.min(100, Math.round(n * 100 / total)) + '%';
  };

  // Show more: fetch the next page, append its cards, move focus to the first new one, put ?page=N in the address
  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-hh-more-btn]');
    if (!btn || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    const nav = btn.closest('[data-hh-more]');
    const grid = nav && nav.parentElement.querySelector('.hh-pl-grid');
    if (!grid) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    const url = btn.href;
    try {
      const doc = await getPage(url);
      const items = itemsOf(doc).filter(li => keepItem(grid, li));
      if (!items.length) throw new Error('no items');
      const first = items.find(li => li.matches('.hh-pl-grid__item')) || items[0];
      items.forEach(li => grid.append(document.adoptNode(li)));
      const next = doc.querySelector('[data-hh-more]');
      const nextBtn = next && next.querySelector('[data-hh-more-btn]');
      const count = nav.querySelector('.hh-pl-more__count'), bar = nav.querySelector('.hh-pl-more__bar i');
      if (next) {
        const c = next.querySelector('.hh-pl-more__count'), b = next.querySelector('.hh-pl-more__bar i');
        if (count && c) count.textContent = c.textContent;
        if (bar && b) bar.style.width = b.style.width;
      }
      if (nextBtn) btn.href = nextBtn.href;
      else {
        btn.remove();
        const prev = nav.querySelector('.hh-pl-more__prev');
        if (!prev) nav.querySelector('.hh-pl-more__links')?.remove();
      }
      try { history.replaceState(Object.assign({}, history.state, { hhY: scrollY }), '', url); } catch (err) {}
      const link = first.querySelector('a[href]');
      if (link) link.focus({ preventScroll: true });
    } catch (err) {
      location.href = url;  // fall back to the plain page
      return;
    } finally {
      btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
    }
  });

  // how far down the page was, for Back: saved when a piece is opened and when the page is left
  document.addEventListener('click', e => {
    if (e.target.closest('.hh-plp a[href]') && !e.target.closest('[data-hh-more-btn]')) remember({ hhY: scrollY });
  }, true);
  addEventListener('pagehide', () => remember({ hhY: scrollY }));

  // back on ?page=N: put pages 1..N-1 back above, then return to where the page was
  (async () => {
    const here = new URL(location.href), page = parseInt(here.searchParams.get('page') || '1', 10);
    const nav = document.querySelector('[data-hh-more]'), prev = nav && nav.querySelector('[data-hh-prev]');
    const grid = nav && nav.parentElement.querySelector('.hh-pl-grid');
    if (!(page > 1 && page < 20 && prev && grid)) return;
    const y = history.state && typeof history.state.hhY === 'number' ? history.state.hhY : null;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    if (y !== null) grid.style.visibility = 'hidden';
    const reveal = setTimeout(() => { grid.style.visibility = ''; }, 4000);
    try {
      const urls = [];
      for (let p = 1; p < page; p++) { const u = new URL(here); u.searchParams.set('page', p); if (p === 1) u.searchParams.delete('page'); urls.push(u.href); }
      const docs = await Promise.all(urls.map(getPage));
      const before = grid.firstChild;
      docs.forEach(doc => itemsOf(doc).filter(li => keepItem(grid, li)).forEach(li => grid.insertBefore(document.adoptNode(li), before)));
      prev.remove();
      setCount(nav, grid);
    } catch (e) { /* the page as served (page N with its "Previous page" link) still works */ }
    clearTimeout(reveal); grid.style.visibility = '';
    if (y !== null) requestAnimationFrame(() => scrollTo(0, y));
  })();
})();
